module.exports = __webpack_public_path__ + "static/media/select-mat-arrow-up.c4807998.svg";